<template><router-view /></template>